import { Card, Typography, Empty, Button } from 'antd'
import { TeamOutlined, PlusOutlined } from '@ant-design/icons'

const { Title, Paragraph } = Typography

export function WorkspacesPage() {
  return (
    <div>
      <div style={{ marginBottom: 24 }}>
        <Title level={2} style={{ marginBottom: 8 }}>
          Workspaces
        </Title>
        <Paragraph type="secondary" style={{ marginBottom: 0 }}>
          Manage your organizational workspaces and team access
        </Paragraph>
      </div>

      <Card>
        <Empty
          image={<TeamOutlined style={{ fontSize: 64, color: '#52c41a' }} />}
          description={
            <div>
              <Title level={4}>No Workspaces Yet</Title>
              <Paragraph type="secondary">
                Create workspaces to organize your teams and manage access to assessments
              </Paragraph>
            </div>
          }
        >
          <Button type="primary" icon={<PlusOutlined />} size="large">
            Create Workspace
          </Button>
        </Empty>
      </Card>
    </div>
  )
}

